import { type ApiMessageType, type ApiMessage } from '@app/types'
import { Anchor, Stack, Text } from '@mantine/core'
import { notifications, type NotificationProps } from '@mantine/notifications'

import { IconCheck, IconExclamationCircle, IconInfoCircle } from '@tabler/icons-react'
import { each } from 'lodash'

const notificationProps: Record<ApiMessageType, Omit<NotificationProps, 'message'>> = {
  error: {
    autoClose: false,
    color: 'red',
    icon: <IconExclamationCircle />,
    withCloseButton: true
  },
  info: {
    autoClose: true,
    color: 'blue',
    icon: <IconInfoCircle />,
    withCloseButton: false
  },
  success: {
    autoClose: true,
    color: 'green',
    icon: <IconCheck />,
    withCloseButton: false
  },
  warning: {
    autoClose: false,
    color: 'orange',
    icon: <IconExclamationCircle />,
    withCloseButton: true
  }
}

export const showMessageNotification = ({ message, type }: ApiMessage) => {
  const content = <Text dangerouslySetInnerHTML={{ __html: message }} />

  notifications.show({
    ...notificationProps[type],
    message:
      type === 'error' || type === 'warning' ? (
        <Stack spacing={4}>
          {message}
          <Text>
            Need more help?{' '}
            <Anchor
              href={process.env.NEXT_PUBLIC_SUPPORT_URL}
              target='_blank'
            >
              Contact Support
            </Anchor>
          </Text>
        </Stack>
      ) : (
        content
      ),
    withBorder: true
  })
}

export const showMessagesNotifications = (messages?: ApiMessage[]) => each(messages, showMessageNotification)
